var $870f486a212b2216$exports = {};
$870f486a212b2216$exports = {
    "replaceMessage": `De\u{11F}i\u{15F}tirmek i\xe7in dosyay\u{131} b\u{131}rak\u{131}n`
};


export {$870f486a212b2216$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
